import "./botb-leaderboard.css";
import Header from "../header/page";
import { EarnPoints } from "./components/EarnPoints";
import { MobileTabs } from "./components/MobileTabs";
import { DEVICE_RESOLUTION } from "../../app-constants";
import MainBanner from "./components/MainBanner";
import { useEffect, useState } from "react";
import { TermsAndConditions } from "./components/TermsAndConditions";
import { TopSubscribe } from "./components/TopSubscribe";
import { LeaderboardTable } from "./components/LeaderboardTable";
import { useBotbLeaderboardContext } from "./context";

export default function BotBLeaderBoardPageContent() {
  const { activeTab, tournamentFinished } = useBotbLeaderboardContext();
  let whichTabToShow: "leaderboard" | "earn-points" | "all" = "all";
  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    whichTabToShow = activeTab === 0 ? "leaderboard" : "earn-points";
  }

  return (
    <>
      <header className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header isBotBPassHeader={true} isLeaderBoardPage={true} />
      </header>

      <MainBanner />

      {isMobile && !tournamentFinished && <MobileTabs />}

      <div className={"lg:bg-gray-4"}>
        <div className={"w-full max-w-[1232px] mx-auto lg:pt-8 lg:pb-16 flex flex-col gap-10"}>
          {!isMobile && <TopSubscribe />}
          {!tournamentFinished ? (
            <div className={"lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start w-full"}>
              {(whichTabToShow === "leaderboard" || whichTabToShow === "all") && <LeaderboardTable />}
              {(whichTabToShow === "earn-points" || whichTabToShow === "all") && <EarnPoints />}
            </div>
          ) : (
            <LeaderboardTable />
          )}
        </div>
      </div>

      <TermsAndConditions />
    </>
  );
}
